module.exports = __webpack_public_path__ + "static/media/beginChat.512b421e.svg";